'use strict';
import * as storage from 'redux-storage';
import filter from 'redux-storage-decorator-filter';
import debounce from 'redux-storage-decorator-debounce';
import migrate from 'redux-storage-decorator-migrate';
import {storageActions as settingsStorageActions} from '../../settings/actions';
import {storageActions as timersStorageActions} from '../../timers/actions';
import {storageWhitelist as settingsWhitelist} from '../../settings/reducers';
import {storageWhitelist as timersWhitelist} from '../../timers/reducers';
import {createEngine} from './createEngine';

export const currentVersion = 0;
export const stateVersionProp = '_stateVersion';
export const initialState = currentVersion;

export function versionReducer(state = initialState, action) {
  return state;
}

const propsWhitelist = [
  stateVersionProp, // <-- Don't forget to whitelist your state version property
  ...settingsWhitelist,
  ...timersWhitelist,
];
const propsBlacklist = [];

// Needed to load persisted state
export const engine = migrate(
  debounce(
    filter(
      createEngine('redux-storage'),
      propsWhitelist,
      propsBlacklist
    ), 1000
  ),
  currentVersion,
  stateVersionProp,
);

// Your first migration:
// engine.addMigration(1, (state) => { /* migration step for 1 */ return state; });

const actionsWhitelist = [
  ...settingsStorageActions,
  ...timersStorageActions,
];
const actionsBlacklist = [];

export const storageMiddleware = storage.createMiddleware(engine, actionsBlacklist, actionsWhitelist);



// WEBPACK FOOTER //
// ./src/js/config/redux-storage/index.js